import http, { expandURI } from '@/utils/ajax'
import { BATCHGLUPDATE_INIT_LOADING, BATCHGLUPDATE_INIT_SUCCESS, BATCHGLUPDATE_INIT_FAIL } from '@/store/types'
import { extractMenu, extractMessages } from '@/utils/extract'

export const init = {
  async batchGlUpdateInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.batchGlUpdate
    if (apiUrl) {
      commit(BATCHGLUPDATE_INIT_LOADING)
      try {
        const result = await http.get(expandURI(apiUrl))
        const menu = extractMenu(result.data._links)
        let commitResult = result.data
        Object.assign(commitResult, {
          menu: menu
        })
        commit(BATCHGLUPDATE_INIT_SUCCESS, commitResult)
      } catch (error) {
        // console.log(error)
        commit(BATCHGLUPDATE_INIT_FAIL, extractMessages(error))
      }
    } else {
      commit(BATCHGLUPDATE_INIT_FAIL, 'The request failed because it is trying to execute an invalid API url.')
    }
  }
}
